/* eslint-disable */
import { Table, TableContainer } from "@chakra-ui/react";
import {
  AccordionActions,
  Button,
  Card,
  CardContent,
  createStyles,
  Divider,
  Paper,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Theme,
  withStyles,
} from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { builtinModules } from "module";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { show } from "redux-modal";
import {
  deleteToast,
  getAllToasts,
} from "../../../utils/store/actions/toasts.actions";
import ModalCreateToast from "../../Modal/Modal.CreateToast";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    dropzone: {
      fontSize: "8px",
      minHeight: 0,
      border: "dashed 0.8px #919191",
      borderRadius: "10px",
      "& .MuiDropzoneArea-icon": {
        color: "#ae0064",
      },
      "& .MuiDropzoneArea-text": {
        fontSize: "14px",
        margin: 0,
      },
      "& .MuiDropzoneArea-textContainer": {
        margin: "10px",
      },
    },
    previewChip: {
      maxWidth: "300px",
      color: "#ae0064",
    },

    input: {
      "&:focus": {
        outline: "none !important",
        border: "1px solid red",
      },
    },
    fundCards: {
      borderRadius: "12px",
      margin: "0 auto",
      display: "grid",
      gridGap: "1rem",
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: "repeat(3, 1fr)",
      },
    },
    backPageComponent: {
      display: "flex",
      alignItems: "center",
      margin: "1%",
    },
    backButton: {
      borderRadius: "5px",
      backgroundColor: "white",
      margin: "1%",
    },
    backInput: {
      marginLeft: "3%",
      display: "flex",
      alignItems: "center",
      fontSize: "20px",
      color: "black",
    },
    card: {
      borderRadius: "12px",
      margin: "1%",
    },
    tabList: {
      borderBottom: "2px solid #4b0084",
      boxSizing: "border-box",
      marginLeft: "20px",
      width: "100%",
      marginRight: "5%",
    },
    signersComponent: {
      display: "flex",
      width: "30%",
      flexDirection: "column",
    },
    savePart: {
      color: "white",
      textTransform: "none",
      backgroundColor: "#ae0064",
      width: "98%",
      margin: "0.5%",
      position: "sticky",
      bottom: 0,
      marginBottom: "5%",
    },
    chip: {
      margin: 2,
    },
  });
class Bandeau extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      toast: {
        startDate: "",
        expirationDate: "",
        message: "",
        module: "",
      },
    };
  }

  async componentDidMount() {
    await this.props.getAllToasts();
  }

  handleChangeModule(e: any, module: any) {
    if (e.target.checked === true) {
      this.setState({
        modules: [...this.state.modules, module],
      });
    } else {
      this.setState({
        modules: builtinModules.filter((item) => item !== module),
      });
    }
  }

  render() {
    const { Toasts } = this.props;
    const { classes, t } = this.props;
    return (
      <div>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="modules"
          >
            <Typography className={classes.heading}>
              {" "}
              {t("BANDEAU")}{" "}
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            style={{ display: "flex", flexDirection: "column" }}
          >
            <ModalCreateToast />
            <Button
              variant="contained"
              style={{
                marginLeft: "10px",
                color: "white",
                backgroundColor: "#ae0064",
                width: "15%",
              }}
              className={classes.addUser}
              onClick={() =>
                this.props.show("create_toast", {
                  name: "create_toast",
                })
              }
            >
              {t("CREATE_BANDEAU")}
            </Button>
            <Card className={classes.card}>
              <CardContent>
                <TableContainer component={Paper}>
                  <Table stickyHeader aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">{t("START_DATE")}</TableCell>
                        <TableCell align="center">{t("END_DATE")}</TableCell>
                        <TableCell align="center">{t("MODULE")}</TableCell>
                        <TableCell align="center">{t("MESSAGE")}</TableCell>
                        <TableCell align="center"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Toasts.toasts_list?.map((toast: any) => (
                        <TableRow>
                          <TableCell align="center">
                            {new Date(toast.startingDate).toLocaleDateString(
                              "fr"
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {new Date(toast.expirationDate).toLocaleDateString(
                              "fr"
                            )}
                          </TableCell>
                          <TableCell align="center">{toast.module}</TableCell>
                          <TableCell align="center">{toast.message}</TableCell>
                          <TableCell align="center">
                            <Button
                              onClick={() => {
                                this.props
                                  .deleteToast(toast.id)
                                  .then(() => this.props.getAllToasts());
                              }}
                            >
                              <DeleteOutlinedIcon />
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </AccordionDetails>
          <Divider />
          <AccordionActions></AccordionActions>
        </Accordion>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllToasts,
  show,
  deleteToast,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(Bandeau)));
